import { paymentLabel } from './payment'
import { el } from './ui'
import { paymentWords, visitWords, type WordsCustomer, type WordsVisit } from './visit-words'

// The shared visit words (visit-words.ts) drawn as a badge, for the screens that still drew Original's words: the
// customer page, Work and Today (bug hunt 8 Oct 2026, wording-brand 1: "confirmed" there, "Day agreed · time to
// confirm" on the Diary for the same visit). The same words and badge colours as the Diary's New layout.
export function visitBadge(v: WordsVisit, c: WordsCustomer | null, today?: string): HTMLElement {
  const words = visitWords(v, c, today)
  return el('span', { class: `badge visit-words-${words.tone} ${words.tone === 'ok' ? 'badge-booked' : 'badge-unconfirmed'}` }, words.text)
}

// A done visit's payment in Owed's words ("Not paid", "Chased · not paid", "Paid cash"), in its payment colour. Kept
// apart from payment.ts so payment.ts never reads visit-words.ts back (Astra, 8 Oct 2026).
export function paymentWordsBadge(v: WordsVisit): HTMLElement {
  return el('span', { class: `badge ${paymentLabel(v).className}` }, paymentWords(v))
}
